var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTargetFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    viewBox: "0 0 13 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 7138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 51",
    d: "M0.566631 2.99932C5.23742 1.70445 8.82136 7.29287 12.3384 5.21969C12.4822 5.12958 12.5621 5.07728 12.5621 5.07728C12.4876 5.12829 12.413 5.17571 12.3384 5.21969C11.3626 5.83127 7.44672 8.18433 5.6356 7.74527C3.55764 7.24153 0.503662 8.65832 0.503662 8.65832L0.566631 2.99932Z",
    fill: "#F61200",
    stroke: "#F61200",
    strokeWidth: 0.0629685
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 49",
    d: "M1.51114 20.9998H0.440674V1.66846H1.51114V20.9998Z",
    fill: "#EBB17F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 50",
    d: "M0 0.944528C0 0.422879 0.422879 0 0.944528 0C1.46618 0 1.88906 0.422879 1.88906 0.944528C1.88906 1.46618 1.46618 1.88906 0.944528 1.88906C0.422879 1.88906 0 1.46618 0 0.944528Z",
    fill: "#EBB17F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetFlag);
export default __webpack_public_path__ + "static/media/targetFlag.ee88597ae1906ee07a792011e3be6cb1.svg";
export { ForwardRef as ReactComponent };